<template>
  <section class="container relative">
    <div class="bg-blue-lighter py-4 md:mb-4">
      <Swiper ref="quoteSwiper" :options="contentOptions" class="h-full w-full">
        <SwiperSlide v-for="(slide, index) in slides" :key="index">
          <div class="swiper-slide__container text-center">
            <RichTextRenderer
              v-if="slide.fields.content"
              :document="slide.fields.content"
              :node-renderers="renderNodes()"
            />
          </div>
        </SwiperSlide>
      </Swiper>
      <div class="bullets">
        <span
          v-for="(slide, index) in slides"
          :key="index"
          tabindex="0"
          class="bullet"
          :class="{ active: index + 1 === active }"
          @click.prevent="
            () => {
              goToSlide(index + 1);
              touched = false;
            }
          "
          @keyup.enter="
            () => {
              goToSlide(index + 1);
              touched = false;
            }
          "
        ></span>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.swiper-slide__container {
  max-width: 566px;
  margin: auto;
  padding: 0 20px;

  p {
    color: #00263e !important;
    line-height: 34px;
  }
  p:first-of-type {
    font-size: 24px;
  }
}

::v-deep .bullets {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 10px;
  .bullet {
    width: 12px;
    height: 12px;
    display: flex;
    border-radius: 25px;
    background-color: grey;
    margin: 16px;
    cursor: pointer;

    &.active {
      background-color: darkgrey;
    }
  }
}
</style>
<script>
import RichTextRenderer from "contentful-rich-text-vue-renderer";
import EntryRenderer from "../../modules/EntryRenderer";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";

import "swiper/swiper-bundle.min.css";

export default {
  components: {
    Swiper,
    SwiperSlide,
    RichTextRenderer
  },
  mixins: [EntryRenderer],
  props: {
    slides: {
      type: Array,
      required: true
    }
  },
  computed: {
    quoteSwiper() {
      return this.$refs.quoteSwiper.$swiper;
    }
  },
  methods: {
    goToSlide(index) {
      this.active = index;
      this.quoteSwiper.slideTo(index);
    },
    handleSlideChange() {
      this.active = this.$refs && this.$refs.quoteSwiper && this.$refs.quoteSwiper.$swiper ? this.$refs.quoteSwiper.$swiper.activeIndex : 1;
    },
  },
  data() {
    return {
      active: 1,
      touched: false,
      contentOptions: {
        loop: true,
        autoplay: {
          delay: 1000,
          disableOnInteraction: true
        },
        slidesPerView: 1,
        allowTouchMove: true,
        effect: "slide",
        on: {
          slideChange: this.handleSlideChange
        },
      }
    };
  }
};
</script>
